import {
    doGetQCXRequest,
    doPostQCXRequest,
    doPutQCXActivateRequest,
    doPutQCXInactivateRequest,
    doPutQCXRequest,
} from '../../utils/api/domain/domain-api-utils';

import { HOUSE_FETCH_ALL } from '../../utils/api/domain/domain-endpoint-utils'

async function fetchAll(queryParams = []) {
    console.log('query params', queryParams)
    return doGetQCXRequest([HOUSE_FETCH_ALL, 'filter'], queryParams)
}

async function fetchById(id) {
    return doGetQCXRequest(
        [HOUSE_FETCH_ALL, id]
    )
}

async function register(data,queryParams = []) {
    return doPostQCXRequest(
        [HOUSE_FETCH_ALL],
        data,
        queryParams
    );
}

async function save(data,queryParams = []) {
    return doPutQCXRequest(
        [HOUSE_FETCH_ALL],
        data,
        queryParams
    );
}

async function activateById(id) {
    return doPutQCXActivateRequest(
        [HOUSE_FETCH_ALL],
        id
    );
}

async function inactivateById(id) {
    return doPutQCXInactivateRequest(
        [HOUSE_FETCH_ALL],
        id
    );
}

const aereoAPI = {
    fetchAll,
    fetchById,
    register,
    save,
    activateById,
    inactivateById,
}

export {
    aereoAPI,
    fetchAll,
    fetchById,
    register,
    save,
    activateById,
    inactivateById,
}